export default __webpack_public_path__ + "static/media/mediaTypeGt.fcc6e9e2.svg";